/**
 * Get a nested value from an object using dot notation path.
 * Replaces lodash/get for this specific use case.
 *
 * @param obj The object to extract value from
 * @param path Dot notation path (e.g., 'data.data' or 'response.user.name')
 * @returns The value at the path, or undefined if not found
 */
export function getNestedValue(obj: unknown, path: string): unknown {
  return path.split(".").reduce((current, key) => {
    if (current && typeof current === "object" && key in current) {
      return (current as Record<string, unknown>)[key];
    }
    return undefined;
  }, obj);
}

/**
 * Check if an error message indicates an authentication failure
 */
export function isAuthErrorMessage(message: string): boolean {
  const authErrorPatterns = [
    "invalid token",
    "expired token",
    "token expired",
    "unauthorized",
    "invalid_token",
    "access_denied",
  ];
  const lowerMessage = message.toLowerCase();
  return authErrorPatterns.some((pattern) => lowerMessage.includes(pattern));
}
